import PLAYNGOSLOTActions from './PLAYNGOSLOTActions'

export default class PLAYNGOBINGOActions extends PLAYNGOSLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'PLAYNGO',
      gameType: 'BINGO',
      gameCode: 'PLAYNGO-BINGO-001',
    }

    this.gameName = 'Rainforest Magic Bingo'
  }
}
